// methods here build URLs for site pages

export default {
    methods: {
        buildDraftDetailUrl(draft) {
            let url = '/draft-detail/'
            url += draft.PatternID
            if (draft.DisplayTitle) {
                url += '/'
                url += encodeURIComponent(this.sanitizeUrlSegment(draft.DisplayTitle))
            }
            return url
        },

        buildDraftProfileUrl(draft) {
            let url = '/profile/'
            url += draft.PatternID
            if (draft.DisplayTitle) {
                url += '/'
                url += encodeURIComponent(this.sanitizeUrlSegment(draft.DisplayTitle))
            }
            return url
        },

        buildCollectionPageUrl(collection, collectionPageNumber) {
            let url = '/collection-drafts/collection/'
            url += collection.BookID + '/'
            url += encodeURIComponent(this.sanitizeUrlSegment(collection.TitleWithAuthors)) + '?page='
            url += collectionPageNumber
            return url
        },

        buildMatchingThreadingsCollectionUrl(patternId, threadingHash, isTurned, isStraightened, isPointed) {
            let url = '/collection-drafts/threading/'
            url += '?patternId=' + patternId
            url += '&threadingHash=' + threadingHash
            url += '&isTurned=' + (isTurned ? '1' : '0')
            url += '&isStraightened=' + (isStraightened ? '1' : '0')
            url += '&isPointed=' + (isPointed ? '1' : '0')
            url += '&page=0'
            return url
        },

        buildMatchingTagsCollectionUrl(tagId, tagName, searchType) {
            let url = '/collection-drafts/' + searchType + '/' + tagId + '/'
            url += encodeURIComponent(this.sanitizeUrlSegment(tagName))
            url += '?page=0'
            return url
        },

        buildEditDraftUrl(patternId, isTurned, isStraightThreading, isStraightTreadling, isPointThreading, isPointTreadling) {
            let url = '/draft-editor/' + patternId
            let params = []
            if (isTurned) {
                params.push('t=true')
            }
            if (isStraightThreading) {
                params.push('sth=true')
            }
            if (isStraightTreadling) {
                params.push('str=true')
            }
            if (isPointThreading) {
                params.push('pth=true')
            }
            if (isPointTreadling) {
                params.push('ptr=true')
            }
            for (let c=0; c < params.length; c++) {
                url += (c===0) ? '?' : '&'
                url += params[c]
            }
            return url
        },

        buildDocumentDetailUrl(document) {
            let url = '/document-detail/'
            // console.log('buildDocumentDetailUrl, document: ' + JSON.stringify(document))
            url += document.ItemID + '/'
            url += encodeURIComponent(this.sanitizeUrlSegment(document.SEOName))
            return url
        },

        buildDocumentSearchTypeUrl(searchType, itemId, urlTitle) {
            let url = '/document-search/' + searchType + '/' + itemId + '/' + this.sanitizeUrlSegment(urlTitle)
            return url
        },

        sanitizeUrlSegment(url) {
            var lowercase = url.toLowerCase()

            // replace common accents for neat urls
            let r = lowercase.replace(new RegExp(/[àáâãäå]/g), 'a')
            r = r.replace(new RegExp(/æ/g), 'ae')
            r = r.replace(new RegExp(/ç/g), 'c')
            r = r.replace(new RegExp(/[èéêë]/g), 'e')
            r = r.replace(new RegExp(/[ìíîï]/g), 'i')
            r = r.replace(new RegExp(/ñ/g), 'n')
            r = r.replace(new RegExp(/[òóôõö]/g), 'o')
            r = r.replace(new RegExp(/œ/g), 'oe')
            r = r.replace(new RegExp(/[ùúûü]/g), 'u')
            r = r.replace(new RegExp(/[ýÿ]/g), 'y')

            // replace other non-alpha characters for neat seo token urls
            var nosquarebrackets = r.replace(/[\[\]']+/g, '') // eslint-disable-line no-useless-escape
            var alphaNumericsOnly=nosquarebrackets.replace(/[^a-z0-9]/gi, ' ')
            var nodoublespaces = alphaNumericsOnly.replace(/\s{2,}/g, ' ')
            nodoublespaces = nodoublespaces.replace(/\s{2,}/g, ' ')
            var nospaces = nodoublespaces.replace(/\s/g, '-')
            return window.encodeURIComponent(nospaces)
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/urlsService.js